module.exports = __webpack_public_path__ + "static/media/gestoria_amarillo.099d8b0d.svg";